module.exports = __webpack_public_path__ + "bbacf477ea283fb31e5da1ddf97d6b92.pdf";